import React from "react";

import "./UserDetails.scss";

// https://www.w3schools.com/jsref/jsref_tolocalestring.asp
const parseDate = (date) =>
  new Date(date).toLocaleString("es-MX", {
    dataStyle: "medium",
    month: "long",
    year: "numeric",
    timeZoneName: "short",
  });

const firstLetter = (str) => str.charAt(0).toUpperCase();

const UserDetails = ({ user }) => (
  <div id="user-details">
    <div className="wrapper-letters">
      <div className="round-letters">
        <p>
          {firstLetter(user.first_name)}
          {firstLetter(user.last_name)}
        </p>
      </div>
    </div>
    <div className="details">
      <p className="title">Bienvenido</p>
      <p className="user-name">
        {user.first_name} {user.last_name}
      </p>
      <p className="since">Lector desde {parseDate(user.date_joined)}</p>
    </div>
  </div>
);

export default UserDetails;
